// @ts-nocheck
import { useEffect, useState } from 'react';
import { Dialog } from "primereact/dialog";
import { ListBox } from 'primereact/listbox';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import "../assets/functionalComponents/_dialog.scss"

export const GoogleSearchComponents = (props) => {
    const [searchSrting, setSearchSrting] = useState('');
    const [searchResult, setSearchResult] = useState([]);
    const [selectedResult, setSelectedResult] = useState(null);

    useEffect(() => {
        if (searchSrting.length === 0) {
            setSearchResult([]);
            return null;
        }

        let URL = "";
        URL += "https://mapserver.pilotgaea.com.tw/oviewTLS12.aspx?https://maps.googleapis.com/maps/api/place/textsearch/json?";;
        URL += "query=" + searchSrting + "+in+Taiwan&";		    //指定在台灣地區
        URL += "language=zh-TW&";				        //指定返還的資源使用的語言
        URL += "key=AIzaSyC8Qoy-nO1uLULyvtODx1tqvag9amx7yjs";
        fetch(URL)
            .then(res => res.json())
            .then(
                (data) => {
                    if (data.status === "OK") {
                        setSearchResult(data.results);
                    }
                }
            )
    }, [searchSrting])

    useEffect(() => {
        if (window.main.OView === null)
            return null;
        let DefaultCustomer = window.main.OView.findLayer("_SearchControllerDefaultCustomer");
        if (DefaultCustomer === null) {
            DefaultCustomer = window.main.OView.addCustomLayer({
                layername: "_SearchControllerDefaultCustomer"
            });
        }
        else {
            DefaultCustomer.removeAllEntity();
        }
        if (searchResult.length === 0)
            return null;

        searchResult.forEach(
            (Results) => {
                let param = {};
                param.geo = new window.GeoPoint(Results.geometry.location.lng, Results.geometry.location.lat, 10);//幾何
                param.color = "#ffffff";
                param.opacity = 1.0;//不透明
                param.size = 30;//大小
                param.symbol = Results.icon;
                param.maxDisplayDistance = 250000;
                param.absHeight = false; //是否為絕對高度
                param.label = { color: "#B0C4D0", text: Results.name, font: "微軟正黑體", size: 20, borderColor: "000000", borderSize: 5 }; //加上文字Label
                let PointEntity = DefaultCustomer.addPointEntity(param);
                PointEntity.setTooltip(Results.formatted_address);
                PointEntity.setOnClickListener(function (mouse, attr) {
                    window.main.OView.goto(param.geo, 1000, false);
                });

            }
        );
        DefaultCustomer.setDepthTest(false);
        DefaultCustomer.setAfterTerrainDraw(true);
    }, [searchResult])

    useEffect(() => {
        if (selectedResult === null)
            return null;
        let Point = new window.GeoPoint(selectedResult.geometry.location.lng, selectedResult.geometry.location.lat);
        window.main.OView.goto(Point, 1000, false);
    }, [selectedResult])

    const mapItemTemplate = (option) => {
        return (
            <div>
                <h5>{option.name}</h5>
                <sub>{option.formatted_address}</sub>
            </div>

        );
    }
    const clearResult = () => {
        setSearchSrting('');
        setSearchResult([]);
        setSelectedResult(null);
    }

    return (
        <Dialog header="Google地圖搜尋" visible={props.GoogleSearch} modal={false} keepInViewport={false} onHide={() => props.onHide('GoogleSearch')}>
            <div className="field grid" style={{ marginBottom: "1rem" }}>
                <div className="col-8 md:col-9" >
                    <span className="p-input-icon-left" style={{ width: "100%" }}>
                        <i className="pi pi-search" />
                        <InputText value={searchSrting} onChange={(e) => setSearchSrting(e.target.value)} placeholder="Search" style={{ width: "100%" }} />
                    </span>
                </div>
                <div className="col-4 md:col-3">
                    <Button label="清除" icon="pi pi-trash" className="p-button-danger" onClick={clearResult} style={{ width: "100%", height: "100%" }} />
                </div>
            </div>
            <ListBox value={selectedResult} options={searchResult} onChange={(e) => setSelectedResult(e.value)} optionLabel="name" style={{ width: '100%' }} itemTemplate={mapItemTemplate} listStyle={{ maxHeight: "40vh" }} />
        </Dialog>
    );
}